import { Routes, Route } from 'react-router-dom';
import { Navigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import TopTimesContextView from './TopTimesContextView';

import TopTimesLscSearch from './topTimesLscSearch/TopTimesLscSearch';
import TopTimesClubSearch from './topTimesClubSearch/TopTimesClubSearch';
import TopTimesLscSelection from './topTimesLscSelection/TopTimesLscSelection';
import TopTimesClubSelection from './topTimesClubSelection/TopTimesClubSelection';
import TopTimesNationalSearch from './topTimesNationalSearch/TopTimesNationalSearch';

import EventsDwContextProvider from '../../state/topTimes/eventsDw/EventsDwContextProvider';
import TimeStandardsDwContextProvider from '../../state/topTimes/timeStandardsDw/TimeStandardsDwContextProvider';
import ReportPeriodSeasonsDwContextProvider from '../../state/topTimes/reportPeriodSeasonsDw/ReportPeriodSeasonsDwContextProvider';
import EventCompetitionGendersDwContextProvider from '../../state/topTimes/eventCompetitionGendersDw/EventCompetitionGendersDwContextProvider';

import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import LscContextProvider from '@usas/ui-web/state/lsc/LscContextProvider';
import ZoneContextProvider from '@usas/ui-web/state/zone/ZoneContextProvider';
import SelectOrgUnitContextProvider from '@usas/ui-web/state/selectOrgUnit/SelectOrgUnitContextProvider';
import PersonOrgRoleContextProvider from '@usas/ui-web/state/personOrgRole/PersonOrgRoleContextProvider';

const ContextRoutes = ({ navRoutes }) => (
  <TopTimesContextView>
    <Routes>
      <Route path={navRoutes['TOP_TIMES_LSC_SEARCH']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['TOP_TIMES_LSC_SEARCH']}
            editElement={<TopTimesLscSearch />} />
        } />
      <Route path={navRoutes['TOP_TIMES_CLUB_SEARCH']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['TOP_TIMES_CLUB_SEARCH']}
            editElement={<TopTimesClubSearch />} />
        } />
    </Routes>
  </TopTimesContextView>
);

const TopTimesRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <Routes>
      <Route path={navRoutes['TOP_TIMES_NATIONAL_SEARCH']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['TOP_TIMES_NATIONAL_SEARCH']}
            editElement={<TopTimesNationalSearch />} />
        } />
      <Route path={navRoutes['TOP_TIMES_LSC_SELECT']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['TOP_TIMES_LSC_SELECT']}
            editElement={<TopTimesLscSelection />} />
        } />
      <Route path={navRoutes['TOP_TIMES_CLUB_SELECT']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['TOP_TIMES_CLUB_SELECT']}
            editElement={<TopTimesClubSelection />} />
        } />

      <Route path={'/*'} element={<ContextRoutes navRoutes={navRoutes} />} />
      <Route path={'/'} element={<Navigate to={navRoutes['TOP_TIMES_NATIONAL_SEARCH']?.route} replace />} />
    </Routes>
  );
};

const TopTimes = () => (
  <EventsDwContextProvider>
    <EventCompetitionGendersDwContextProvider>
      <ReportPeriodSeasonsDwContextProvider>
        <TimeStandardsDwContextProvider>
          <ZoneContextProvider>
            <LscContextProvider>
              <PersonOrgRoleContextProvider>
                <SelectOrgUnitContextProvider>
                  <TopTimesRoutes />
                </SelectOrgUnitContextProvider>
              </PersonOrgRoleContextProvider>
            </LscContextProvider>
          </ZoneContextProvider>
        </TimeStandardsDwContextProvider>
      </ReportPeriodSeasonsDwContextProvider>
    </EventCompetitionGendersDwContextProvider>
  </EventsDwContextProvider>
);

export default TopTimes;